import { loadUsetifulScript } from 'usetiful-sdk';
import { setUsetifulTags } from 'usetiful-sdk';
import _ from "lodash";
import {getCreatedDateEpoch, getLastLoginDateEpoch, getUser, getUserId, getUserSettings} from "../common/UserService";
import Utils from "../common/Utils";
import abtest from "../common/abtest";

export const initUsetiful = () => {
    loadUsetifulScript('6554d50b3fcb5b25161a7c15028e3863');
    if (getUserId() === 0) return;
    const user = getUser()
    const tags = {
        'userId': getUserId(),
        'firstName': _.capitalize(user.firstName),
        'lastName': _.capitalize(user.lastName),
        'username': user.username,
        'fullname': Utils.getFullname(user),
        'last_login_date': getLastLoginDateEpoch(),
        'create_date': getCreatedDateEpoch(),
        'ab_test': abtest.abTestId,
        'ab_test_var': abtest.uid,
    }
    const userSettings = getUserSettings();
    if (!_.isEmpty(userSettings)) {
        if (!_.isEmpty(userSettings.subscription)) {
            tags.sub_active = _.result(userSettings, 'subscription.active', false);
            tags.sub_id = _.result(userSettings, 'subscription.sub_id', '');
            tags.sub_created_at = _.result(userSettings, 'subscription.start_date', '');
            tags.sub_product_id = _.result(userSettings, 'subscription.product_id', '');
            tags.sub_price_id = _.result(userSettings, 'subscription.price_id', '');
            tags.sub_status = _.result(userSettings, 'subscription.status', '');
        }
        if (userSettings.school_name) {
            tags.school_name = userSettings.school_name;
        }
        if (userSettings.job_title) {
            tags.job_title = userSettings.job_title;
        }
        if (userSettings.ref) {
            tags.ref = userSettings.ref;
        }
        addUsetifulTags(tags)
    }
}

export const addUsetifulTags = (tags) => {
    setUsetifulTags(tags);
}
